"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import Pristine from "../libs/pristine/pristine.js";
import {onEnterViewPort} from "@elements/viewport-utils";
import {matches} from "@elements/dom-utils";

const defaultOptions = {
    classTo: 'form-group',
    errorClass: 'has-error',
    successClass: 'has-success',
    errorTextParent: 'form-group',
    // type of element to create for the error text
    errorTextTag: 'div',
    // class of the error text element
    errorTextClass: 'form-errors invalid-feedback'
};

const defaultSelectors = {
    base: '.js-form-validation'
};

let pristineForms = [];

export function init(options = defaultOptions, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        createFormValidation(
            baseElement,
            {...defaultOptions, ...options},
            {...defaultSelectors, ...selectors}
        );
    });
}

export function createFormValidation(form, options, selectors) {

    onEnterViewPort(form, function () {
        const pristine = new Pristine(form, options);

        form.addEventListener('submit', function (e) {
            // check if the form is valid
            if (!pristine.validate()){
                e.preventDefault();
            }
        });
    });

}

export function isValidationForm (form) {
    return matches('.js-form-validation', form);
}

export function isValid(form) {
    if(matches('form', form)){
        const pristine = new Pristine(form, defaultOptions);
        return pristine.validate();
    }else{
        return 'Using parsley without form';
    }
}
